import { action } from "satcheljs";
import type { ClientItemId } from "owa-client-ids";

export interface OnMailServiceOpenItemActionMessage {
    clientItemId: ClientItemId;
    isPopOut?: boolean;
}

const onMailServiceOpenItem: (clientItemId: ClientItemId, isPopOut?: boolean) => OnMailServiceOpenItemActionMessage = action("onMailServiceOpenItem", (clientItemId: ClientItemId, isPopOut?: boolean): OnMailServiceOpenItemActionMessage => ({
    clientItemId,
    isPopOut,
}));

export default onMailServiceOpenItem;
